import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CssBaseline from '@material-ui/core/CssBaseline';
import MailIcon from '@material-ui/icons/Mail';
import { fade } from '@material-ui/core/styles/colorManipulator';
import NotificationsIcon from '@material-ui/icons/Notifications';
// import NotificationList from '../../components/Customer/NotificationList.jsx';
import logo from '../../assets/img/logo1.jpg';
import {
    Avatar,
    Typography,
    ListItemIcon,
    ListItemText,
    Toolbar,
    AppBar,
    IconButton,
    Badge,
    MenuItem,
    Menu,
    Drawer,
    ListItem,
    Dialog,
    Slide,
    DialogContent,
    DialogTitle,
    DialogContentText
} from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dashboard from '../User/Dashboard.jsx';
import Profile from '../User/Profile.jsx';
import ProfileDashboard from '../User/ProfileDashboard';
import CustomerAddress from '../User/Address.jsx';
import ProviderService from '../User/ProviderService.jsx';
import { Booking } from '../User/Booking.jsx';
import { Route, Switch, Redirect, Link } from 'react-router-dom';
import SideNav from '../SideBar/SideNav';
import HOCLoader from '../../components/HOC/HOCLoader.jsx';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import { compose } from 'redux';
import { withTheme, withStyles } from '@material-ui/core/styles';
import Favourite from './Favourite.jsx';
import withUser from '../../components/HOC/HOCwithUser.jsx';
import NotificationList from '../User/Notification.jsx';
import PromocodeList from '../User/Promocode.jsx';
import Inbox from './Inbox.jsx';
import ChangePassword from './ChangePassword';
import { ROLE_CUSTOMER, ROLE_PROVIDER, SERVER_URL } from '../../utils/config/constants';
import ProviderDashboard from '../User/ProviderDashboard.jsx';
import ProviderBooking from '../User/ProviderBooking.jsx';
import PendingBooking from '../User/PendingBooking.jsx';
import { AccountBalanceWallet, Star, Close, ExitToApp, RemoveCircle } from '@material-ui/icons';
import { FormattedMessage, injectIntl } from 'react-intl';
import Hidden from '@material-ui/core/Hidden';
import ChatPanel from '../../components/Customer/ChatPanel.jsx';
import MenuIcon from '@material-ui/icons/Menu';
import { store } from '../../store';
import SideNotificationList from '../../components/Customer/SideNotificationList';
import NotAllowed from '../NotAllowed';
import SosList from '../User/Sos.jsx';
import ReferList from '../User/Refer.jsx';
import BookingCalendarList from '../User/BookingCalendar.jsx';
import Help from '../User/Help.jsx';
import MaintenanceList from '../User/Maintenance.jsx';
import Employees from '../User/Employees.jsx';
import RecurringBookingList from '../User/RecurringBooking.jsx';
import ReviewList from '../User/Review.jsx';
import HolidayList from '../User/Holiday.jsx';
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import BlockedList from '../../components/Customer/BlockedList';
import CustomerWalletList from '../../components/Customer/CustomerWalletList';
import uploadIcon from '../../assets/img/profile-upload-icon.png'
import Dropzone from 'react-dropzone';
import { NotificationManager } from 'react-notifications';
import UserDashboardNew from '../User/UserDashboardNew';
import ServicesListScreenNew from '../User/ServicesListScreenNew';
import TaskListScreenNew from './TaskListScreenNew';
import BookingScheduleScreenNew from './BookingScheduleScreenNew';
import AdditionalInfoScreenNew from './AdditionalInfoScreenNew';
import ConfirmBookingScreenNew from './ConfirmBookingScreenNew';
import BookingSuccessScreenNew from './BookingSuccessScreenNew';
import ManageBookingsScreenNew from './ManageBookingsScreenNew';
import ManageBookingsCategoryScreenNew from './ManageBookingsCategoryScreenNew';
import BookingDetailsScreenNew from './BookingDetailsScreenNew';
import ViewAdditionalInfoScreenNew from './ViewAdditionalInfoScreenNew';
import RebookingScreenNew from './RebookingScreenNew';
import BookingApprovalScreenNew from './BookingApprovalScreenNew';
import BookingRejectionScreenNew from './BookingRejectionScreenNew';
import RevisePriceDetailsScreenNew from './RevisePriceDetailsScreenNew';
import RescheduleBookingScreenNew from './RescheduleBookingScreenNew';
import ProviderInfoScreenNew from './ProviderInfoScreenNew';
import ReferAndEarnScreenNew from './ReferAndEarnScreenNew';
import UserTutorialsScreenNew from './UserTutorialsScreenNew';
import { cookies, getCookies } from '../../utils/getToken';
import ConfirmBookingScreenNewLayout from './ConfirmBookingScreenNewLayout';
import BookingDetailsNewLayout from './BookingDetailsNewLayout';
import ProviderDashboardNew from '../ProviderScreensNew/ProviderDashboardNew';
import ProviderManageBookingsNew from '../ProviderScreensNew/ProviderManageBookingsNew';
import ProviderBookingDetailsNew from '../ProviderScreensNew/ProviderBookingDetailsNew';
import ProviderRescheduleBookingNew from '../ProviderScreensNew/ProviderRescheduleBookingNew';
import ProviderBookingCompletionNew from '../ProviderScreensNew/ProviderBookingCompletionNew';
import ProposeNewPriceScreenNew from '../ProviderScreensNew/ProposeNewPriceScreenNew';
import ProviderManageTodaysBookingsNew from '../ProviderScreensNew/ProviderManageTodaysBookingsNew';
import ProviderTodaysBookingDetailsNew from '../ProviderScreensNew/ProviderTodaysBookingDetailsNew';
import "./index.css"
import Axios from "axios";
import { roundUpTransaction } from '../../utils/roundUpTransaction.js';
import { cardList } from '../../apiHelpers/booking/list';
import CreditsListScreenNew from './CreditsListScreenNew';
import { Grid } from 'react-loader-spinner';
import AreYouSureAlert from '../../components/Alert/AreYouSureAlert.jsx';


//  var authToken = getCookies();
//console.log("AUTH TOKENNN", authToken);

const AddProfileImage = ({ title, handleDropRejected, handleDrop, userData, imageUploaded, front_imageId, noOfUpload = 1, onlyAdd = false }) => {
    return (
        <React.Fragment>
            {(() => {
                const arr = [];
                for (let i = 0; i < noOfUpload; i++) {
                    arr.push(
                        <div
                            style={{
                                position: "absolute",
                                //top: "150px",
                                // left: "210px" 
                                //right: '105px'
                            }}>
                            <Dropzone
                                onDrop={handleDrop}
                                accept="image/jpeg,image/jpg,image/png"
                                multiple={true}
                                maxSize={10485760}
                                onDropRejected={handleDropRejected}
                            >
                                {({ getRootProps, getInputProps }) => (
                                    <div {...getRootProps()}>
                                        <input {...getInputProps()} />
                                        <img src={uploadIcon} style={{ height: "25px", width: "25px", cursor: "pointer" }} />

                                    </div>
                                )}
                            </Dropzone>
                        </div>
                    );
                }
                return arr;
            })()}
        </React.Fragment>
    );
}

// const drawerWidth = `20%`;

const sendRouterProps = props => {
    return props;
};

var drawerColor = "#ffffff"

const styles = theme => ({
    root: {
        display: 'flex',
        color: theme.palette.primary.main,
        backgroundColor: '#eaedef',
        position: 'relative',
        overflow: 'hidden',
        paddingLeft: '50px',
        paddingRight: '50px',
        paddingTop: '100px',
        paddingBottom: '20px',
        [theme.breakpoints.down('xs')]: {
            paddingLeft: '20px',
            paddingRight: '20px',
            paddingTop: '80px',
            paddingBottom: '50px'
        }
    },
    appBar: {
        backgroundColor: theme.palette.primary.main,

        [theme.breakpoints.up('sm')]: {
            width: `100%`
        }
    },
    drawer: {
        [theme.breakpoints.up('sm')]: {
            flexShrink: 0
        }
    },
    drawerPaper: {
        width: '100%',
        backgroundColor: drawerColor
    },
    toolbar: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        color: theme.palette.secondary.text,
        padding: theme.spacing.unit * 3
    },

    grow: {
        flexGrow: 1
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 5,

        [theme.breakpoints.up('sm')]: {
            display: 'none'
        }
    },
    title: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block'
        }
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25)
        },
        marginRight: theme.spacing.unit * 2,
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit * 3,
            width: 'auto'
        }
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    inputRoot: {
        color: 'inherit',
        width: '100%'
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '100%'
        }
    },
    sectionDesktop: {
        // display: 'none',
        // [theme.breakpoints.up('md')]: {
        //     display: 'flex'
        // }
    },
    sectionMobile: {
        display: 'flex',
        padding: 0
        // [theme.breakpoints.up('md')]: {
        //     display: 'none'
        // }
    }
});
const sendProps = props => {
    const { classes, ...rest } = props;
    return rest;
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
class CustomerMain extends Component {
    constructor(props) {
        super();
        this.refreshInterval = 0;
        this.state = {
            anchorEl: '',
            anchorE2: '',
            mobileMoreAnchorEl: '',
            redirect: false,
            redirectMain: false,
            allNotifications: false,
            language: 'en',
            mobileOpen: false,
            notificationDrawerOpen: false,
            zoomImageModal: false,
            zoomSrc: "",
            initialProfile: false,
            profileImagebase64Data: null,
            transaction: 0,
            refer_amount: 0,
            totalAmount: 0,
            earnings_total: 0,
            pathname: props.history.location.pathname,
            open: false,
            show_deactivate_alert: false
        };
        this.handleProfilePicDrop = this.handleProfilePicDrop.bind(this);
    }
    handleDrawerToggle = () => {
        this.setState(prevState => ({
            mobileOpen: !prevState.mobileOpen
        }));
        this.forceUpdate();
    };

    handleDrawerToggleNotification = () => {
        this.setState(prevState => ({
            notificationDrawerOpen: !prevState.notificationDrawerOpen
        }));
        this.forceUpdate();
    }
    handleCloseZoomImage = () => {
        this.setState({
            zoomImageModal: false
        })
    }


    componentDidMount() {
        //        console.log("AUTH TOKENNN", authToken);
        //this.props.notificationListAction();
        this.props.removeHeaderAction(true);
        this.props.bookingListAction({ page: 1, append: false });
        this.props.favouriteListAction();
        this.getCreditData()
        this.getReferData()
        this.getEarningsData()

    }

    componentWillUnmount() {
        this.props.removeHeaderAction(false);
    }

    // componentDidUpdate(){
    //     var authToken = getCookies();
    // }

    logoutCall = async () => {
        this.props.logoutAction(this.onDone);
    };


    handleClose = () => {
        this.setState({ open: false });
    }

    // openModel = () => {
    //     this.setState({ open: true });
    // }

    // handleYes = () => {
    //     this.handleClose();
    // }

    openModel = () => {
        // const confirmation = window.confirm("Are you sure?");
        // if(confirmation == true){
        //     this.deactivate()
        // }

        this.setState({ show_deactivate_alert: true })
    }

    deactivate = async () => {
        this.props.deactivateAction(
            {
                role: store.getState().auth.userData.role
            },
            this.onDone
        );
    }

    onDone = (success, data) => {
        if (success) {
            console.log(data)
            this.setState({
                redirectMain: true,
                //              authToken: cookies.remove("x-auth-token", { path: "/" })    
            });
        }
    };

    handleProfileMenuOpen = event => {
        this.setState({ anchorEl: event.currentTarget });
    };
    handleNotificationMenuOpen = event => {
        this.setState({ anchorE2: event.currentTarget });
    };
    handleNotiMenuClose = () => {
        this.setState({ anchorE2: null });
        this.handleMobileMenuClose();
    };
    handleMenuClose = () => {
        this.setState({ anchorEl: null });
        this.handleMobileMenuClose();
    };

    handleMobileMenuOpen = event => {
        this.setState({ mobileMoreAnchorEl: event.currentTarget });
    };

    handleMobileMenuClose = () => {
        this.setState({ mobileMoreAnchorEl: null });
    };
    redirectMainWebsite = () => {
        this.setState({ redirectMain: true });
    };
    getNotificationBadge = () => {
        let countNoti = 0;
        this.props.notificationData.filter(noti => {
            if (noti.is_read == 2) {
                countNoti = parseInt(countNoti) + 1;
            }
        });
        return countNoti;
    };
    userProfile = () => {
        this.props.history.push(`/user/profile`);
    };
    changePassword = () => {
        this.props.history.push(`/user/changepassword`);
    };
    clickNotification = notification => {
        this.handleNotiMenuClose();
        if (notification.route == 'BookingDetail') {
            this.props.history.push({
                pathname:
                    notification.webroute +
                    '/' +
                    notification.notification.payload.additionalData.params
                        .bookingDetail.key,
                bookingId:
                    notification.notification.payload.additionalData.params
                        .bookingDetail.key
            });
        } else if (notification.route == 'Offers') {
            this.props.history.push({
                pathname: notification.webroute
            });
        }
    };

    renderUnreadNotification = () => {
        return this.props.notificationData.slice(0, 10).map((noti, index) => {
            return (
                <MenuItem style={{ fontSize: 14 }} key={index}>
                    <ListItemIcon>
                        <NotificationsIcon />
                    </ListItemIcon>
                    <ListItemText
                        onClick={() => this.clickNotification(noti)}
                        primary={
                            noti.is_read == 2 ? (
                                <Typography
                                    color="primary"
                                    variant="inherit"
                                    noWrap
                                >
                                    {/* {noti.notification.payload.body} */}
                                </Typography>
                            ) : (
                                <Typography variant="inherit" noWrap>
                                    {/* {noti.notification.payload.body} */}
                                </Typography>
                            )
                        }
                    />
                    {/* <ListItemSecondaryAction>
                        {convertTimestampToDate(noti.created_at * 1000)}
                    </ListItemSecondaryAction> */}
                </MenuItem>
            );
        });
    };
    listAllNotification = () => {
        this.setState({ allNotifications: true });
    };


    handleWalletClick = () => {
        this.props.history.push({
            pathname: `/user/profile`,
            state: { value: 3 }
        });
    };


    handleChangeLanguage = event => {
        this.setState({ [event.target.name]: event.target.value });
        this.props.changeLanguageAction({ language: event.target.value });
        document.documentElement.lang = event.target.value;
    };

    // handleDropRejected = (...args) => console.log('reject', args);

    _handleReaderLoaded = e => {
        console.log("file uploaded 2: ", e);
        let binaryString = e.target.result;
        this.setState({
            profileImagebase64Data: btoa(binaryString)
        });
    };

    handleProfilePicDrop(files) {
        console.warn("CHOOSING profile pic", files)
        const file = files[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoaded.bind(this);
            reader.readAsBinaryString(file);
        }
        var fData = new FormData()
        if (store.getState().auth.userData.role == ROLE_CUSTOMER) {
            fData.append('attribute', "profile_img");
        } else {
            fData.append("attribute", "logo");
        }
        fData.append('image', files[0])
        this.props.idActionUpload(
            fData,
            store.getState().auth.userData.role,
            this.onProfilePicDone
        )
    }

    onProfilePicDone = (success, data) => {
        console.log("success, data,files", success, data)
        if (success) {
            console.log(data.data, 'image upload')
            this.setState({
                profile_image: data.data.url,
                imageUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)

            })
        } else {
            this.setState({
                imageUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }

    handleDropRejected = (...args) => console.log('reject', args);






    getCreditData = async () => {
        var authToken = getCookies();
        try {
            const { data } = await Axios({
                method: 'get',
                url: `${SERVER_URL}/booking/get-user-credit`,
                headers: {
                    'x-auth-Token': authToken,
                },
            });
            console.log('credit data new', data);
            if (data.status == 'OK') {
                this.setState({
                    transaction: data.data.total_amount,
                })
            }
            else {
                this.setState({
                    transaction: 0
                })
            }
        } catch (error) {
            console.log("get credit ERRORRRRRR", error);
        }
    }

    getReferData = async () => {
        var authToken = getCookies();
        try {
            const { data } = await Axios({
                method: 'post',
                url: `${SERVER_URL}/refer/get-refer-amount`,
                headers: {
                    'x-auth-Token': authToken,
                },
            });
            console.log('refer data new', data);
            if (data.status == 'OK') {
                this.setState({
                    refer_amount: data.data.total_amount,
                })
            }
            else {
                this.setState({
                    refer_amount: 0
                })
            }
        } catch (error) {
            console.log("get refer ERRORRRRRR", error);
        }
    }

    getEarningsData = async () => {
        var authToken = getCookies();
        try {
            const { data } = await Axios({
                method: 'get',
                url: `${SERVER_URL}/booking/get-provider-credit`,
                headers: {
                    'x-auth-Token': authToken,
                },
            });
            console.log('credit data new', data);
            if (data.status == 'OK') {
                this.setState({
                    earnings_total: data.data.total_amount
                })
            }
            else {
                this.setState({
                    transaction: 0
                })
            }
        } catch (error) {
            console.log("====================get credit ERRORRRRRR", error);
        }
    }

    sumAmount = (credit, refer) => {
        let totalCreditAmount = credit + refer
        let roundUpValue = totalCreditAmount.toString()

        if (roundUpValue.includes('.')) {
            return Number(totalCreditAmount).toFixed(2)
        } else {
            return Number(totalCreditAmount)
        }
    }

    imageSource = () => {
        const profileImg = store.getState().auth.userData.profile_img;
        return profileImg && !profileImg.includes("null")
            ? profileImg
            : store.getState().auth.userData.image.medium;
    };

    imageSourceProvider = () => {
        const profileImg = store.getState().auth.userData.profile_img;
        return profileImg && !profileImg.includes("null")
            ? profileImg
            : store.getState().auth.userData.proImage.small;
    };






    render() {
        var totalAmount = this.sumAmount(this.state.transaction, this.state.refer_amount);
        var totalAmountProvider = roundUpTransaction(this.state.earnings_total);
        console.log(totalAmount);
        console.log("asdfvgfdsasdf", this.state.pathname);
        console.log("State Data", store.getState().auth)
        var authToken = getCookies();
        // console.log("userData ====",store.getState().auth.userData);
        const { anchorEl, mobileMoreAnchorEl, anchorE2 } = this.state;
        const { classes, userData } = this.props;
        const isMenuOpen = Boolean(anchorEl);
        const isNotiMenuOpen = Boolean(anchorE2);
        const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
        drawerColor = this.props.colors.BACKGROUND.HEX;
        // console.log(classes, 'classes in index.js')

        const renderMenu = (
            <Menu
                className="modal-fixed-to"
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={isMenuOpen}
                onClose={this.handleMenuClose}
            />
        );

        const renderNotificationMenu = (
            <Menu
                className="modal-fixed-to"
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={isNotiMenuOpen}
                onClose={this.handleNotiMenuClose}
            >
                {this.renderUnreadNotification()}

                <ListItem
                    onClick={this.listAllNotification}
                    style={{ cursor: 'pointer' }}
                >
                    <FormattedMessage
                        id="seeAllNotifications"
                        defaultMessage="See All Notifications"
                    />
                </ListItem>
            </Menu>
        );

        const renderMobileMenu = (
            <Menu
                className="modal-fixed-to"
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={isMobileMenuOpen}
                onClose={this.handleMobileMenuClose}
            >
                <MenuItem>
                    <IconButton color="inherit">
                        <Badge badgeContent={4} color="secondary">
                            <MailIcon />
                        </Badge>
                    </IconButton>
                    <p>
                        <FormattedMessage
                            id="messages"
                            defaultMessage="Messages"
                        />
                    </p>
                </MenuItem>
                <MenuItem>
                    <IconButton color="inherit">
                        <Badge
                            badgeContent={this.getNotificationBadge()}
                            color="secondary"
                        >
                            <NotificationsIcon />
                        </Badge>
                    </IconButton>
                    <p>
                        <FormattedMessage
                            id="notifications"
                            defaultMessage="Notifications"
                        />
                    </p>
                </MenuItem>

                <MenuItem onClick={this.handleProfileMenuOpen}>
                    <IconButton color="inherit">
                        {store.getState().auth.userData.role == ROLE_CUSTOMER
                            ? store.getState().auth.userData.image && (
                                <Avatar
                                    alt="User Profile"
                                    src={
                                        this.state.profileImagebase64Data ?
                                            `data:image;base64,${this.state.profileImagebase64Data}` :
                                            store.getState().auth.userData.image
                                                .small
                                    }
                                    className={classes.avatar}
                                />
                            )
                            : store.getState().auth.userData.profile_img && (
                                <React.Fragment>
                                    <Avatar
                                        alt="User Profile"
                                        src={
                                            store.getState().auth.userData
                                                .profile_img
                                        }
                                        className={classes.avatar}
                                    />
                                    <p>hello</p>
                                </React.Fragment>
                            )}
                    </IconButton>


                    <p>
                        <FormattedMessage
                            id="profile"
                            defaultMessage="Profile"
                        />
                    </p>
                </MenuItem>
            </Menu>
        );

        if (this.state.redirectMain) {
            return <Redirect to={'/'} />;
        }
        if (this.state.allNotifications) {
            this.props.history.push(`/notification/list`);
        }

        // console.log("619 IMAGE", store.getState().auth.userData);

        return (
            <HOCLoader loading={this.props.authLoader}>
                <div className={classes.root + ' tz'}
                    style={{
                        justifyContent: 'center',
                        // justifyContent: 'space-around', 
                        ///justifyContent: `${authToken == 'Guest' ? 'center' : 'space-around'}`,
                        // backgroundColor: 'skyblue', 
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingTop: 80
                    }}>
                    <CssBaseline />

                    <div>
                        <AppBar position="fixed" className={classes.appBar}>
                            <Toolbar>
                                <img
                                    style={{
                                        cursor: 'pointer'
                                    }}
                                    onClick={store.getState().auth.userData
                                        .role == ROLE_CUSTOMER
                                        ? this.redirectMainWebsite
                                        :
                                        authToken == 'Guest' || authToken == null
                                            ?
                                            () => {
                                                cookies.remove('x-auth-token', { path: '/' });
                                                window.location.href = 'https://ezprohome.com';
                                                //this.props.history.push(`/`);
                                            }
                                            :
                                            () => {
                                                this.props.history.push(`/`);
                                            }}
                                    src={this.props.settings.constants.LOGO != "" ? this.props.settings.constants.LOGO : logo}
                                    width="100px"
                                    height="auto"
                                    alt='mainlog'
                                />
                                <IconButton
                                    id="iconbitNoti"
                                    color='inherit'
                                    aria-label="Open drawer"
                                    className={classes.menuButton}
                                    onClick={this.handleDrawerToggleNotification}
                                    edge="start"
                                >
                                    <Badge
                                        badgeContent={this.getNotificationBadge()}
                                        color="secondary"
                                    >
                                        <NotificationsIcon />
                                    </Badge>

                                </IconButton>
                                <IconButton
                                    className={classes.menuButton}
                                    id="iconbitn"
                                    color="inherit"
                                    aria-label="Open drawer"
                                    edge="start"
                                    onClick={this.handleDrawerToggle}
                                >
                                    <MenuIcon />
                                </IconButton>
                                <div className={classes.grow} />
                            </Toolbar>
                        </AppBar>
                        {renderMenu}
                        {renderMobileMenu}
                        {/* {this.props.notificationData.length > 0 &&
                            renderNotificationMenu} */}
                    </div>

                    {/* SIDEBAR CONTAINER */}
                    {
                        (store.getState().auth.userData.name != '' && authToken !== 'Guest') ?
                            <div className={classes.drawer + ' sidebar-drawer'}
                                style={{
                                    // backgroundColor: 'red', 
                                    marginLeft: 0
                                }}>
                                <div className="tz-l">
                                    <Hidden xsDown implementation="css">
                                        <div className="tz-l-1" style={{ backgroundColor: this.props.colors.SECONDARY.HEX, padding: 10 }}>
                                            <ul>
                                                <li>
                                                    {
                                                        // authToken !== 'Guest' 
                                                        // ?
                                                        // <Hidden xsDown implementation="css">
                                                        <div className="dashboard-profile-image">

                                                            <div id='pofileImgPicker'>
                                                                <IconButton
                                                                    className="btn-profile"
                                                                    aria-owns={
                                                                        isMenuOpen
                                                                            ? 'material-appbar'
                                                                            : undefined
                                                                    }
                                                                    aria-haspopup="true"
                                                                    onClick={
                                                                        () => {
                                                                            console.log("IMAGEDDDDD ICON PREDSSSD");
                                                                            this.setState({
                                                                                zoomImageModal: true,
                                                                                zoomSrc: this.state.profileImagebase64Data ?
                                                                                    `data:image;base64,${this.state.profileImagebase64Data}` :
                                                                                    store.getState()
                                                                                        .auth
                                                                                        .userData
                                                                                        .profile_img


                                                                            })
                                                                        }
                                                                    }
                                                                    color="inherit"
                                                                >
                                                                    {store.getState().auth.userData
                                                                        .role == ROLE_CUSTOMER
                                                                        ? store.getState().auth
                                                                            .userData.image && (
                                                                            <Avatar
                                                                                alt="User Profile"
                                                                                src={
                                                                                    this.state.profileImagebase64Data ?
                                                                                        `data:image;base64,${this.state.profileImagebase64Data}` :
                                                                                        this.imageSource()
                                                                                }
                                                                                className="hide-md"
                                                                                style={{
                                                                                    width: '50%',
                                                                                    marginLeft: '23%'
                                                                                }}
                                                                            />
                                                                        )
                                                                        : store.getState().auth
                                                                            .userData
                                                                            .proImage && (
                                                                            <div>
                                                                                <Avatar
                                                                                    alt="Provider Profile"
                                                                                    src={
                                                                                        this.state.profileImagebase64Data ?
                                                                                            `data:image;base64,${this.state.profileImagebase64Data}` :
                                                                                            this.imageSourceProvider()
                                                                                    }
                                                                                    className="hide-md"
                                                                                    style={{
                                                                                        width: '50%',
                                                                                        marginLeft: '23%'
                                                                                    }}
                                                                                />
                                                                                {/* <p>Hiieee</p> */}
                                                                            </div>
                                                                        )}
                                                                </IconButton>
                                                                <AddProfileImage
                                                                    handleDrop={this.handleProfilePicDrop}
                                                                    handleDropRejected={this.handleDropRejected}
                                                                    userData={userData}
                                                                    state={this.state}
                                                                    imageUploaded={this.state.imageUploaded}
                                                                    // front_imageId={this.state.front_imageId}
                                                                    noOfUpload={1}
                                                                />
                                                            </div>
                                                            <div className="" style={{
                                                                paddingTop: 10
                                                            }}>
                                                                {store.getState().auth.userData
                                                                    .role == ROLE_PROVIDER && (
                                                                        <React.Fragment>

                                                                        </React.Fragment>
                                                                    )}
                                                                {(store.getState().auth.userData
                                                                    .role == ROLE_CUSTOMER || store.getState().auth.userData
                                                                        .role == ROLE_PROVIDER) && (
                                                                        <h4 style={{ color: this.props.colors.PRIMARY.HEX }}>
                                                                            Hello, {
                                                                                store.getState()
                                                                                    .auth.userData
                                                                                    .name
                                                                            }
                                                                        </h4>
                                                                    )}
                                                                <div className="user-wallet">
                                                                    {
                                                                        store.getState().auth
                                                                            .userData.role ==
                                                                        ROLE_CUSTOMER &&
                                                                        this.props.settings
                                                                            .constants
                                                                            .WALLET_ACTIVE && (
                                                                            <IconButton
                                                                                className="btn-login mr-2"
                                                                                aria-owns={
                                                                                    isNotiMenuOpen
                                                                                        ? 'material-appbar'
                                                                                        : undefined
                                                                                }
                                                                                aria-haspopup="true"
                                                                                style={{ color: this.props.colors.PRIMARY.HEX }}
                                                                                onClick={
                                                                                    this
                                                                                        .handleWalletClick
                                                                                }
                                                                            >
                                                                                <Badge
                                                                                    className="badge-noti"
                                                                                    badgeContent={totalAmount}
                                                                                    style={{ color: this.props.colors.PRIMARY.HEX }}
                                                                                >
                                                                                    <AccountBalanceWallet style={{ color: this.props.colors.PRIMARY.HEX }} />
                                                                                </Badge>
                                                                            </IconButton>
                                                                        )}
                                                                    {
                                                                        store.getState().auth
                                                                            .userData.role ==
                                                                        ROLE_PROVIDER &&
                                                                        this.props.settings
                                                                            .constants
                                                                            .WALLET_ACTIVE && (
                                                                            <IconButton
                                                                                className="btn-login mr-2"
                                                                                aria-owns={
                                                                                    isNotiMenuOpen
                                                                                        ? 'material-appbar'
                                                                                        : undefined
                                                                                }
                                                                                aria-haspopup="true"
                                                                                style={{ color: this.props.colors.PRIMARY.HEX }}
                                                                                onClick={
                                                                                    this
                                                                                        .handleWalletClick
                                                                                }
                                                                            >
                                                                                <Badge
                                                                                    className="badge-noti"
                                                                                    badgeContent={totalAmountProvider}
                                                                                    style={{ color: this.props.colors.PRIMARY.HEX }}
                                                                                >
                                                                                    <AccountBalanceWallet style={{ color: this.props.colors.PRIMARY.HEX }} />
                                                                                </Badge>
                                                                            </IconButton>
                                                                        )}
                                                                </div>
                                                                {
                                                                    (store.getState().auth
                                                                        .userData.role ==
                                                                        ROLE_CUSTOMER || store.getState().auth
                                                                            .userData.role ==
                                                                        ROLE_PROVIDER)
                                                                    &&
                                                                    <Link to={{
                                                                        pathname: "/user/profile",
                                                                        state: { value: null, loginPath: null, booking_data: null, taskdata: null, res: null }
                                                                    }}>
                                                                        <span style={{
                                                                            color: 'white',
                                                                            textDecoration: 'underline',
                                                                            cursor: 'pointer',
                                                                            fontSize: 17
                                                                        }}>Edit Profile</span>
                                                                    </Link>
                                                                }
                                                            </div>

                                                        </div>
                                                    }

                                                </li>
                                            </ul>
                                        </div>
                                    </Hidden>
                                </div>

                                <div implementation="css">

                                    <Drawer
                                        variant="temporary"
                                        anchor="left"
                                        open={this.state.mobileOpen}
                                        onClose={this.handleDrawerToggle}
                                        classes={{
                                            paper:
                                                classes.drawerPaper +
                                                ' SideNav-arab tz-l-2'
                                        }}
                                        ModalProps={{
                                            keepMounted: true // Better open performance on mobile.
                                        }}
                                    >

                                        {/* Side Nav User Image */}
                                        <div className="tz-l">
                                            <div className="tz-l-1" style={{ backgroundColor: this.props.colors.SECONDARY.HEX, padding: 10 }}>
                                                <ul>
                                                    <li>
                                                        {
                                                            <div className="dashboard-profile-image">
                                                                <div id='pofileImgPicker'>
                                                                    <IconButton
                                                                        className="btn-profile"
                                                                        aria-owns={
                                                                            isMenuOpen
                                                                                ? 'material-appbar'
                                                                                : undefined
                                                                        }
                                                                        aria-haspopup="true"
                                                                        onClick={
                                                                            () => {
                                                                                console.log("IMAGEDDDDD ICON PREDSSSD");
                                                                                this.setState({
                                                                                    zoomImageModal: true,
                                                                                    zoomSrc: this.state.profileImagebase64Data ?
                                                                                        `data:image;base64,${this.state.profileImagebase64Data}` :
                                                                                        store.getState()
                                                                                            .auth
                                                                                            .userData
                                                                                            .proImage
                                                                                            .small
                                                                                })
                                                                            }
                                                                        }
                                                                        color="inherit"
                                                                    >
                                                                        {store.getState().auth.userData
                                                                            .role == ROLE_CUSTOMER
                                                                            ? store.getState().auth
                                                                                .userData.image && (
                                                                                <Avatar
                                                                                    alt="User Profile"
                                                                                    src={
                                                                                        this.state.profileImagebase64Data ?
                                                                                            `data:image;base64,${this.state.profileImagebase64Data}` :
                                                                                            this.imageSource()
                                                                                    }
                                                                                    className="hide-md"
                                                                                    style={{
                                                                                        width: '50%',
                                                                                        marginLeft: '23%'
                                                                                    }}
                                                                                />
                                                                            )
                                                                            : store.getState().auth
                                                                                .userData
                                                                                .proImage && (
                                                                                <div>
                                                                                    <Avatar
                                                                                        alt="Provider Profile"
                                                                                        src={
                                                                                            this.state.profileImagebase64Data ?
                                                                                                `data:image;base64,${this.state.profileImagebase64Data}` :
                                                                                                this.imageSourceProvider()
                                                                                        }
                                                                                        className="hide-md"
                                                                                        style={{
                                                                                            width: '50%',
                                                                                            marginLeft: '23%'
                                                                                        }}
                                                                                    />
                                                                                    {/* <p>Hiieee</p> */}
                                                                                </div>
                                                                            )}
                                                                    </IconButton>
                                                                    <AddProfileImage
                                                                        handleDrop={this.handleProfilePicDrop}
                                                                        handleDropRejected={this.handleDropRejected}
                                                                        userData={userData}
                                                                        state={this.state}
                                                                        imageUploaded={this.state.imageUploaded}
                                                                        noOfUpload={1}
                                                                    />
                                                                </div>
                                                                <div className="" style={{
                                                                    paddingTop: 10
                                                                }}>
                                                                    {(store.getState().auth.userData
                                                                        .role == ROLE_CUSTOMER || store.getState().auth.userData
                                                                            .role == ROLE_PROVIDER) && (
                                                                            <h4 style={{ color: this.props.colors.PRIMARY.HEX }}>
                                                                                Hello, {
                                                                                    store.getState()
                                                                                        .auth.userData
                                                                                        .name
                                                                                }
                                                                            </h4>
                                                                        )}

                                                                    <div className="user-wallet">
                                                                        {
                                                                            store.getState().auth
                                                                                .userData.role ==
                                                                            ROLE_CUSTOMER &&
                                                                            this.props.settings
                                                                                .constants
                                                                                .WALLET_ACTIVE && (
                                                                                <IconButton
                                                                                    className="btn-login mr-2"
                                                                                    aria-owns={
                                                                                        isNotiMenuOpen
                                                                                            ? 'material-appbar'
                                                                                            : undefined
                                                                                    }
                                                                                    aria-haspopup="true"
                                                                                    style={{ color: this.props.colors.PRIMARY.HEX }}
                                                                                    onClick={
                                                                                        this
                                                                                            .handleWalletClick
                                                                                    }
                                                                                >
                                                                                    <Badge
                                                                                        className="badge-noti"
                                                                                        badgeContent={totalAmount}
                                                                                        style={{ color: this.props.colors.PRIMARY.HEX }}
                                                                                    >
                                                                                        <AccountBalanceWallet style={{ color: this.props.colors.PRIMARY.HEX }} />
                                                                                    </Badge>
                                                                                </IconButton>
                                                                            )}
                                                                        {
                                                                            store.getState().auth
                                                                                .userData.role ==
                                                                            ROLE_PROVIDER &&
                                                                            this.props.settings
                                                                                .constants
                                                                                .WALLET_ACTIVE && (
                                                                                <IconButton
                                                                                    className="btn-login mr-2"
                                                                                    aria-owns={
                                                                                        isNotiMenuOpen
                                                                                            ? 'material-appbar'
                                                                                            : undefined
                                                                                    }
                                                                                    aria-haspopup="true"
                                                                                    style={{ color: this.props.colors.PRIMARY.HEX }}
                                                                                    onClick={
                                                                                        this
                                                                                            .handleWalletClick
                                                                                    }
                                                                                >
                                                                                    <Badge
                                                                                        className="badge-noti"
                                                                                        badgeContent={totalAmountProvider}
                                                                                        style={{ color: this.props.colors.PRIMARY.HEX }}
                                                                                    >
                                                                                        <AccountBalanceWallet style={{ color: this.props.colors.PRIMARY.HEX }} />
                                                                                    </Badge>
                                                                                </IconButton>
                                                                            )}
                                                                    </div>
                                                                    <div style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center'
                                                                    }}>
                                                                        {
                                                                            (store.getState().auth
                                                                                .userData.role ==
                                                                                ROLE_CUSTOMER || store.getState().auth
                                                                                    .userData.role ==
                                                                                ROLE_PROVIDER)
                                                                            &&
                                                                            <Link to={{
                                                                                pathname: "/user/profile",
                                                                                state: { value: null, loginPath: null, booking_data: null, taskdata: null, res: null }
                                                                            }}>
                                                                                <span style={{
                                                                                    color: 'white',
                                                                                    textDecoration: 'underline',
                                                                                    cursor: 'pointer',
                                                                                    fontSize: 17,
                                                                                }}>Edit Profile</span>
                                                                            </Link>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }

                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <a className="sidebar-menus-close" onClick={this.handleDrawerToggle}><i class="fa fa-times" aria-hidden="true" /></a>

                                        <SideNav {...sendProps(this.props)}
                                            isMainPage={false}
                                        />
                                        <div style={{ backgroundColor: this.props.colors.BACKGROUND.HEX, marginTop: 20, borderRadius: 4 }}>
                                            {store.getState().auth.userData.name != '' && (
                                                <ul style={{ paddingBottom: 0, }}>

                                                    <MenuItem style={{ color: "#ffffff", backgroundColor: "#0078FF", flexDirection: "row", paddingLeft: 20 }} onClick={this.logoutCall}>
                                                        <ExitToApp />
                                                        <p style={{ marginLeft: 20, marginTop: 10, color: "#ffffff" }}>LOG-OUT</p>
                                                    </MenuItem>
                                                    {/* <MenuItem style={{ flexDirection: "row", paddingLeft: 20 }} onClick={this.openModel}>
                                                        <RemoveCircle />
                                                        <p style={{ marginLeft: 20, marginTop: 10, color: "red", alignItems: 'center' }}>Deactivate Account</p>
                                                    </MenuItem> */}
                                                </ul>
                                            )}
                                        </div>
                                    </Drawer>


                                    <Drawer
                                        variant="temporary"
                                        anchor="left"
                                        open={this.state.notificationDrawerOpen}
                                        onClose={this.handleDrawerToggleNotification}
                                        classes={{
                                            paper:
                                                classes.drawerPaper +
                                                ' SideNav-arab tz-l-2'
                                        }}
                                        ModalProps={{
                                            keepMounted: true
                                        }}
                                    >
                                        <a className="sidebar-menus-close" onClick={this.handleDrawerToggleNotification}><i class="fa fa-times" aria-hidden="true" /></a>
                                        <SideNotificationList />
                                    </Drawer>
                                </div>



                                <Hidden xsDown implementation="css">
                                    <Drawer
                                        classes={{
                                            paper:
                                                classes.drawerPaper +
                                                ' SideNav-arab tz-l-2'
                                        }}
                                        variant="permanent"
                                        anchor="left"
                                        open
                                    >
                                        <SideNav {...sendProps(this.props)} />
                                    </Drawer>
                                </Hidden>
                                <Hidden xsDown implementation="css">
                                    <div style={{ backgroundColor: this.props.colors.BACKGROUND.HEX, marginTop: 20, borderRadius: 4 }}>
                                        {store.getState().auth.userData.name != '' && (
                                            <ul style={{ paddingBottom: 0, }}>
                                                <MenuItem style={{ color: "#ffffff", backgroundColor: "#0078FF", flexDirection: "row", paddingLeft: 20 }} onClick={this.logoutCall}>
                                                    <ExitToApp />
                                                    <p style={{ marginLeft: 20, marginTop: 10, color: "#ffffff" }}>LOG-OUT</p>
                                                </MenuItem>

                                                {/* <MenuItem style={{ flexDirection: "row", paddingLeft: 20 }} onClick={this.openModel}>
                                                    <RemoveCircle />
                                                    <p style={{ marginLeft: 20, marginTop: 10, color: "red", alignItems: 'center' }}>Deactivate Account</p>
                                                </MenuItem> */}

                                            </ul>
                                        )}
                                    </div>
                                </Hidden>
                            </div>
                            : null
                    }

                    {/* MIDDLE CONTAINER */}
                    <div
                        id="Test1"
                        className={classes.content + ' tz-2 dashboard-main-div'}
                        style={{
                            maxWidth: '57%',
                            overflowY: 'auto'
                            // backgroundColor: 'yellowgreen' 
                        }}
                    >
                        {(store.getState().auth.userData.name != '' && authToken !== 'Guest') && (
                            <Switch className="tz-2-com tz-2-main">
                                {
                                    store.getState().auth.userData.role ===
                                    ROLE_CUSTOMER
                                    &&
                                    <Route
                                        path={`/user/dashboard`}
                                        render={props => (
                                            <UserDashboardNew
                                                {...sendProps(this.props)}
                                                {...sendRouterProps(...props)}
                                                logoutCall={this.logoutCall}
                                            />
                                        )}
                                    />
                                }
                                {
                                    store.getState().auth.userData.role ===
                                    ROLE_PROVIDER &&
                                    <Route
                                        path={`/provider/dashboard`}
                                        render={props => (
                                            <ProviderDashboardNew
                                                {...sendProps(this.props)}
                                                {...sendRouterProps(...props)}
                                            />
                                        )}
                                    />
                                }
                                {/* <Route
                                    path={`/user/dashboard`}
                                    render={props =>
                                        store.getState().auth.userData.role ===
                                            ROLE_CUSTOMER ? (
                                            <UserDashboardNew
                                                {...sendProps(this.props)}
                                                {...sendRouterProps(...props)}
                                                logoutCall={this.logoutCall}
                                            />
                                        ) : (
                                            <ProviderDashboard
                                                {...sendProps(this.props)}
                                                {...sendRouterProps(...props)}
                                            />
                                        )
                                    }
                                /> */}
                                <Route
                                    path={'/user/services/:mastercategory_id'}
                                    render={props => (
                                        <ServicesListScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/tasks`}
                                    render={props => (
                                        <TaskListScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/booking_confirm`}
                                    render={props => (
                                        <ConfirmBookingScreenNewLayout
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/booking_schedule`}
                                    render={props => (
                                        <BookingScheduleScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/additional_info`}
                                    render={props => (
                                        <AdditionalInfoScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/view_additional_info`}
                                    render={props => (
                                        <ViewAdditionalInfoScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/provider_info`}
                                    render={props => (
                                        <ProviderInfoScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/confirm_booking`}
                                    render={props => (
                                        <ConfirmBookingScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/booking_success`}
                                    render={props => (
                                        <BookingSuccessScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/manage_bookings`}
                                    render={props => (
                                        <ManageBookingsScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/bookings_list`}
                                    render={props => (
                                        <ManageBookingsCategoryScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/bookings_details`}
                                    render={props => (
                                        <BookingDetailsNewLayout
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/rebook`}
                                    render={props => (
                                        <RebookingScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/reschedule`}
                                    render={props => (
                                        <RescheduleBookingScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/booking_approval`}
                                    render={props => (
                                        <BookingApprovalScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/booking_rejection`}
                                    render={props => (
                                        <BookingRejectionScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/revise_price_request`}
                                    render={props => (
                                        <RevisePriceDetailsScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/refer_friend`}
                                    render={props => (
                                        <ReferAndEarnScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/tutorials`}
                                    render={props => (
                                        <UserTutorialsScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                {/* changes made by pooja on 21/11 */}
                                {/* <Route
                                    path={`/user/profile/initial`}
                                    render={props => (
                                        <ProfileDashboard
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                /> */}
                                <Route
                                    path={`/user/profile`}
                                    render={props => (
                                        <Profile
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />

                                {/* <Route
                                    path={`/user/changepassword`}
                                    render={props => (
                                        <ChangePassword
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                /> */}
                                <Route
                                    path={`/user/address`}
                                    render={props => (
                                        <CustomerAddress
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />

                                <Route
                                    path={`/notification/list`}
                                    render={props => (
                                        <NotificationList
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/booking`}
                                    render={props => (
                                        <Booking
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />

                                <Route
                                    path={`/recurringbookings`}
                                    render={props => (
                                        <RecurringBookingList
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />
                                {/* <Route
                                    path={`/provider/booking`}
                                    render={props => (
                                        <ProviderBooking
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                /> */}
                                <Route
                                    path={`/provider/manage_bookings`}
                                    render={props => (
                                        <ProviderManageBookingsNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/provider/manage_todays_bookings`}
                                    render={props => (
                                        <ProviderManageTodaysBookingsNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/provider/booking/:id`}
                                    render={props => (
                                        <ProviderBookingDetailsNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/provider/booking_today/:id`}
                                    render={props => (
                                        <ProviderTodaysBookingDetailsNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/provider/booking_reschedule/:id`}
                                    render={props => (
                                        <ProviderRescheduleBookingNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/provider/booking_complete/:id`}
                                    render={props => (
                                        <ProviderBookingCompletionNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/provider/propose_new_price/:id`}
                                    render={props => (
                                        <ProposeNewPriceScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/provider/pendingbooking`}
                                    render={props => (
                                        <PendingBooking
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />

                                <Route
                                    path={`/provider/service`}
                                    render={props => (
                                        <ProviderService
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />

                                <Route
                                    path={`/user/favourite`}
                                    render={props => (
                                        <Favourite
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/promocode/list`}
                                    render={props => (
                                        <PromocodeList
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />

                                <Route
                                    path={`/sos`}
                                    render={props => (
                                        <SosList
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/blockprovider`}
                                    render={props => (
                                        <BlockedList
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />


                                <Route
                                    path={`/refer`}
                                    render={props => (
                                        <ReferList
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />

                                <Route
                                    path={`/review`}
                                    render={props => (
                                        <ReviewList
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/holiday`}
                                    render={props => (
                                        <HolidayList
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/maintenancelog`}
                                    render={props => (
                                        <MaintenanceList
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />

                                <Route
                                    path={`/bookingcalendar`}
                                    render={props => (
                                        <BookingCalendarList
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />

                                <Route
                                    path={`/employees`}
                                    render={props => (
                                        <Employees
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/help`}
                                    render={props => (
                                        <Help
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/inbox`}
                                    render={props => (
                                        <Inbox
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/chat`}
                                    render={props => (
                                        <ChatPanel
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                        />
                                    )}
                                />
                                <Route component={NotAllowed} />
                            </Switch>
                        )
                            // : (
                            //     <Switch className="tz-2-com tz-2-main">
                            //         <Route component={NotAllowed} />
                            //     </Switch>
                            // )
                        }

                        {
                            (store.getState().auth.userData.name == '' || authToken == 'Guest')
                                ?
                                <Switch className="tz-2-com tz-2-main">
                                    <Route
                                        path={`/user/dashboard`}
                                        render={props =>
                                            <UserDashboardNew
                                                {...sendProps(this.props)}
                                                {...sendRouterProps(...props)}
                                                logoutCall={this.logoutCall}
                                            />
                                        }
                                    />
                                    <Route
                                        path={`/user/services`}
                                        render={props => (
                                            <ServicesListScreenNew
                                                {...sendProps(this.props)}
                                                {...sendRouterProps(...props)}
                                                logoutCall={this.logoutCall}
                                            />
                                        )}
                                    />
                                    <Route
                                        path={`/user/tasks`}
                                        render={props => (
                                            <TaskListScreenNew
                                                {...sendProps(this.props)}
                                                {...sendRouterProps(...props)}
                                                logoutCall={this.logoutCall}
                                            />
                                        )}
                                    />
                                    <Route
                                        path={`/user/booking_schedule`}
                                        render={props => (
                                            <BookingScheduleScreenNew
                                                {...sendProps(this.props)}
                                                {...sendRouterProps(...props)}
                                                logoutCall={this.logoutCall}
                                            />
                                        )}
                                    />
                                    <Route
                                        path={`/user/additional_info`}
                                        render={props => (
                                            <AdditionalInfoScreenNew
                                                {...sendProps(this.props)}
                                                {...sendRouterProps(...props)}
                                                logoutCall={this.logoutCall}
                                            />
                                        )}
                                    />
                                    <Route
                                        path={`/user/view_additional_info`}
                                        render={props => (
                                            <ViewAdditionalInfoScreenNew
                                                {...sendProps(this.props)}
                                                {...sendRouterProps(...props)}
                                                logoutCall={this.logoutCall}
                                            />
                                        )}
                                    />
                                    <Route
                                        path={`/user/provider_info`}
                                        render={props => (
                                            <ProviderInfoScreenNew
                                                {...sendProps(this.props)}
                                                {...sendRouterProps(...props)}
                                                logoutCall={this.logoutCall}
                                            />
                                        )}
                                    />
                                    <Route
                                        path={`/user/confirm_booking`}
                                        render={props => (
                                            <ConfirmBookingScreenNew
                                                {...sendProps(this.props)}
                                                {...sendRouterProps(...props)}
                                                logoutCall={this.logoutCall}
                                            />
                                        )}
                                    />
                                    <Route
                                        path={`/user/booking_confirm`}
                                        render={props => (
                                            <ConfirmBookingScreenNewLayout
                                                {...sendProps(this.props)}
                                                {...sendRouterProps(...props)}
                                                logoutCall={this.logoutCall}
                                            />
                                        )}
                                    />
                                    <Route
                                        path={`/user/booking_success`}
                                        render={props => (
                                            <BookingSuccessScreenNew
                                                {...sendProps(this.props)}
                                                {...sendRouterProps(...props)}
                                                logoutCall={this.logoutCall}
                                            />
                                        )}
                                    />
                                    {/* <Route
                                    path={`/user/manage_bookings`}
                                    render={props => (
                                        <ManageBookingsScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                /> */}
                                    {/* <Route
                                    path={`/user/bookings_list`}
                                    render={props => (
                                        <ManageBookingsCategoryScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                /> */}
                                    {/* <Route
                                    path={`/user/bookings_details`}
                                    render={props => (
                                        <BookingDetailsScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                />
                                <Route
                                    path={`/user/rebook`}
                                    render={props => (
                                        <RebookingScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                /> */}
                                    {/* <Route
                                    path={`/user/reschedule`}
                                    render={props => (
                                        <RescheduleBookingScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                /> */}
                                    {/* <Route
                                    path={`/user/booking_approval`}
                                    render={props => (
                                        <BookingApprovalScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                /> */}
                                    {/* <Route
                                    path={`/user/booking_rejection`}
                                    render={props => (
                                        <BookingRejectionScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                /> */}
                                    {/* <Route
                                    path={`/user/revise_price_request`}
                                    render={props => (
                                        <RevisePriceDetailsScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                /> */}
                                    {/* <Route
                                    path={`/user/refer_friend`}
                                    render={props => (
                                        <ReferAndEarnScreenNew
                                            {...sendProps(this.props)}
                                            {...sendRouterProps(...props)}
                                            logoutCall={this.logoutCall}
                                        />
                                    )}
                                /> */}
                                    <Route
                                        path={`/user/tutorials`}
                                        render={props => (
                                            <UserTutorialsScreenNew
                                                {...sendProps(this.props)}
                                                {...sendRouterProps(...props)}
                                                logoutCall={this.logoutCall}
                                            />
                                        )}
                                    />
                                    <Route component={NotAllowed} />
                                </Switch>
                                : null
                        }
                    </div>

                    {/* NOTIFICATION CONTAINER */}
                    {
                        // (userData.review_status && userData.under_review == 1) && 
                        //  authToken !== 'Guest' &&
                        (store.getState().auth.userData.name != '' && authToken !== 'Guest') ?

                            <div className="tz-3"
                                style={{
                                    // height: '125vh',
                                    overflowY: 'auto',
                                    // backgroundColor: 'pink', 
                                    marginRight: 10
                                }}>
                                <div style={{
                                    overflowY: 'auto',

                                }}>
                                    <Hidden xsDown implementation="css">

                                        {/* <h3>NOTIFICATIONSSS</h3> */}
                                        {/* userData conditions added for removing NOtification in initial registered by pooja on 21/11 */}
                                        {store.getState().auth.userData.name != '' && (
                                            <React.Fragment>
                                                <h4>
                                                    <FormattedMessage
                                                        id="notifications"
                                                        defaultMessage="Notifications"
                                                    />
                                                </h4>
                                                <SideNotificationList />
                                            </React.Fragment>
                                        )}
                                    </Hidden>
                                </div>
                            </div>

                            : null
                    }
                </div>
                {this.state.zoomImageModal && <Dialog PaperProps={{
                    style: {
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                    },
                }}
                    fullScreen={true} style={{ background: "transparent" }} open={this.state.zoomImageModal}
                    onClose={this.handleCloseZoomImage} TransitionComponent={Transition}>
                    <AppBar style={{ position: "relative" }}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={this.handleCloseZoomImage} aria-label="close">
                                <Close />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <div className="d-flex justify-content-center" style={{
                        width: "100%", height: "100%",
                        background: "rgba(0,0,0,0.2)", alignContent: "center", alignItems: "center"
                    }}>
                        <Zoom wrapStyle={{ background: null }}>
                            <img alt="crop" src={this.state.zoomSrc} width={500}
                                /* style={{ width: 600, height: 700, }} */ />
                        </Zoom>
                    </div>
                </Dialog>}

                <AreYouSureAlert
                    open={this.state.show_deactivate_alert}
                    title=""
                    content="You are deativating your account. Do you want to continue?"
                    close={() => this.setState({ show_deactivate_alert: false })}
                    handleYes={this.deactivate}
                    handleNo={() => this.setState({ show_deactivate_alert: false })}
                />
            </HOCLoader>
        );
    }
}

CustomerMain.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = ({
    settings,
    auth,
    notification,
    bookings,
    providers
}) => {
    return {
        colors: settings.colors,
        settings: settings,
        userData: auth.userData,
        authLoader: auth.authLoader,
        notificationData: notification.notificationData,
        currentLanguage: settings.currentLanguage,
        bookingData: bookings.bookingData.bookingList,
        bookingLoader: bookings.bookingLoader,
        favouriteData: providers.favProviderList,
        favouriteLoader: providers.favProviderLoader
    };
};
const composedComponent = compose(
    withTheme(),
    withStyles(styles),
    connect(mapStateToProps, actions)
);


export default composedComponent(withUser(CustomerMain));



// WEBPACK FOOTER //
// ./src/views/User/index.jsx